export const MARKET_ID = {
    HK: 1,
    US: 2,
    CN: 3,
    SG: 4,
    AU: 5,
    CA: 6,
    JP: 7,
    MY: 8
};

export const SORT_ID = {
    TRADE: 11, // 交易热度
    SEARCH: 13, // 搜索热度
    NEWS: 15, // 资讯热度
    AVERAGE: 17 // 综合热度
};

export const UP_DOWN_COLOR = {
    RED_UP: 0,
    GREEN_UP: 1
};

export const RANK_TYPE = {
    AUTO: 'auto',
    CUSTOM: 'custom'
};

export const AUTO_PLAY_COUNT = {
    H5: 4,
    PC: 7
};

export const THEME = {
    LIGHT: 'light',
    DARK: 'dark'
};

export const THEME_CONFIG = {
    [THEME.LIGHT]: {
        COLOR: {
            RED: '#F03A55',
            GREEN: '#00A870',
            FLAT: '#627085'
        },
        GRADIENT_START: {
            RED: 'rgba(240, 58, 85, 0.2)',
            GREEN: 'rgba(0, 168, 112, 0.2)',
            FLAT: 'rgba(98, 112, 133, 0.2)'
        },
        GRADIENT_END: {
            RED: 'rgba(240, 58, 85, 0)',
            GREEN: 'rgba(0, 168, 112, 0)',
            FLAT: 'rgba(98, 112, 133, 0)'
        }
    },
    [THEME.DARK]: {
        COLOR: {
            RED: '#E02D48',
            GREEN: '#00A357',
            FLAT: '#627085'
        },
        GRADIENT_START: {
            RED: 'rgba(224, 45, 72, 0.2)',
            GREEN: 'rgba(0, 163, 87, 0.2)',
            FLAT: 'rgba(98, 112, 133, 0.2)'
        },
        GRADIENT_END: {
            RED: 'rgba(224, 45, 72, 0)',
            GREEN: 'rgba(0, 163, 87, 0)',
            FLAT: 'rgba(98, 112, 133, 0)'
        }
    }
};

export const PLATFORM_TYPE = {
    NIUNIU: 'niuniu',
    MOOMOO: 'moomoo'
};
